import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
	FieldWorkerActions,
	FieldWorkerActionTypes,
} from './field-worker.actions';
import { FieldWorker } from 'src/shared/api';

export const fieldWorkerStoreName = 'fieldWorker';

export interface FieldWorkerStoreModel extends FieldWorker {
	dirty?: boolean;
}

export interface FieldWorkerState extends EntityState<FieldWorker> {
	loading?: boolean;
	selectedTeamId?: number[];
	searchText?: string;
	onlyAvailableRwics?: boolean;
	// additional entities state properties
}

export const adapter: EntityAdapter<FieldWorker> = createEntityAdapter<
	FieldWorker
>();

export const initialState: FieldWorkerState = adapter.getInitialState({
	onlyAvailableRwics: false,
	selectedTeamId: []
	// additional entity state properties
});

export function reducer(
	state = initialState,
	action: FieldWorkerActions
): FieldWorkerState {
	switch (action.type) {
		case FieldWorkerActionTypes.FieldWorkersRequested: {
			return { ...state, loading: true };
		}
		case FieldWorkerActionTypes.UpdateSearchText: {
			return { ...state, searchText: action.payload.searchText };
		}
		case FieldWorkerActionTypes.UpdateSelectedTeamId: {
			return { ...state, selectedTeamId: action.payload.selectedTeamId };
		}
		case FieldWorkerActionTypes.UpdateOnlyAvailableRwics: {
			return {
				...state,
				onlyAvailableRwics: action.payload.onlyAvailableRwics,
			};
		}
		case FieldWorkerActionTypes.AddFieldWorker: {
			return adapter.addOne(action.payload.fieldWorker, {
				...state,
				loading: false,
			});
		}

		case FieldWorkerActionTypes.UpsertFieldWorker: {
			return adapter.upsertOne(action.payload.fieldWorker, state);
		}

		case FieldWorkerActionTypes.JobAssignmentsAddFieldWorkers: {
			return adapter.addMany(action.payload.fieldWorkers, {
				...state,
				loading: false
			});
		}

		case FieldWorkerActionTypes.UpsertFieldWorkers: {
			return adapter.upsertMany(action.payload.fieldWorkers, state);
		}

		case FieldWorkerActionTypes.UpdateFieldWorker: {
			return adapter.updateOne(action.payload.fieldWorker, state);
		}

		case FieldWorkerActionTypes.UpdateFieldWorkers: {
			return adapter.updateMany(action.payload.fieldWorkers, state);
		}

		case FieldWorkerActionTypes.DeleteFieldWorker: {
			return adapter.removeOne(action.payload.id, state);
		}

		case FieldWorkerActionTypes.DeleteFieldWorkers: {
			return adapter.removeMany(action.payload.ids, state);
		}

		case FieldWorkerActionTypes.LoadFieldWorkers: {
			return adapter.setAll(action.payload.fieldWorkers, state);
		}

		case FieldWorkerActionTypes.ClearFieldWorkers: {
			return adapter.removeAll(state);
		}

		default: {
			return state;
		}
	}
}

export const {
	selectIds,
	selectEntities,
	selectAll,
	selectTotal,
} = adapter.getSelectors();
